import { styled } from "@mui/material";

export const FooterLinksContainer = styled("nav")(() => ({
  width: "100%",
  display: "flex",
  flexDirection: "row",
  gap: "56px",
}));
